<template>
  <q-dialog v-model="setSellHistoryDialog.show"
            @keydown.escape="close()"
            persistent
            maximized
            transition-show="scale"
            transition-hide="scale">
    <q-card>
      <q-card-section style="height: 64px;">
        <div class="text-h6">Sell history</div>
        <q-btn color="secondary" label="CLEAR" class="q-mr-sm"
               style="position: absolute; top: 14px; right: 230px;" :disable="selectedItems.length < 1"
               @click="clearSelectedItems"/>
        <q-btn color="primary" label="RE-SELL" class="q-mr-sm"
               style="position: absolute; top: 14px; right: 140px;" :disable="selectedItems.length < 1"
               @click="sellVehicles"/>
        <q-btn-dropdown color="grey" icon="fas fa-filter" style="position: absolute; top: 13px; right: 55px;">
          <q-form @submit.prevent.stop="getItems" class="q-pa-md" style="width: 260px;">
            <q-select
              outlined
              class="q-mb-md"
              color="grey-7"
              label-color="grey-7"
              label="Company"
              :options="companies"
              v-model="filter.company"
              emit-value
              map-options
              lazy-rules
              dense
              clearable>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            <q-select
              outlined
              class="q-mb-md"
              color="grey-7"
              label-color="grey-7"
              label="Result"
              :options="results"
              v-model="filter.result"
              emit-value
              map-options
              lazy-rules
              dense
              clearable>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            <q-input v-model="filter.keyword"
                     outlined
                     class="q-mb-md"
                     color="grey-7"
                     label-color="grey-7"
                     label="Keyword"
                     dense
                     clearable></q-input>
            <q-btn type="submit" color="primary" label="Filter" class="full-width"/>
          </q-form>
        </q-btn-dropdown>
        <q-btn round size="sm" color="red" icon="fas fa-times" v-close-popup class="q-mr-sm"
               style="position: absolute; top: 15px; right: 10px;"/>
      </q-card-section>

      <q-separator/>

      <q-card-section style="position:relative; width: 100%; max-height: calc(100vh - 64px)"
                      class="scroll scroll-content" v-on:scroll.native="onScroll">
        <div v-if="!isLoading && items.length === 0" class="text-center text-grey-7 q-pa-md">
          There is no data.
        </div>
        <div v-else>
          <q-card flat bordered v-for="(item, i) in items" :key="item.id"
                  @click="toggleSelectedItem(item)"
                  :class="'cursor-pointer q-pa-md ' + (i + 1 === items.length ? 'q-mb-none' : 'q-mb-md') + getSelectedItemClass(item) + (i % 2 === 0 ? ' odd' : '')">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4">
                <div class="row">
                  <div class="col-6">
                    <strong>{{ item.vehicle.vin }}</strong>
                    <br/>
                    {{ item.vehicle.brand.name }} - {{
                      item.vehicle.model.name
                    }} - {{ item.vehicle.model_detail.name }} ({{ item.vehicle.model_year }})<br/>
                    <strong>Company:</strong> {{ item.vehicle.company.name }}<br/>
                    <strong>Due location name:</strong> {{ item.due_location_name }}<br/>
                    <strong>Pickup location number:</strong> {{ item.pickup_location_number }}
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-4">
                <strong>Price:</strong> {{
                  item.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  })
                }}<br/>
                <span v-if="item.grade !== null">
                  <strong>Grade:</strong> {{ item.grade }}<br/>
                </span>
                <strong>Status:</strong> {{ item.status }}<br/>
                <strong>Retail:</strong> {{ item.retail ? 'Yes' : 'No' }}<br/>
                <strong>Wholesale:</strong> {{ item.wholesale ? 'Yes' : 'No' }}<br/>
                <strong>With MMR:</strong> {{ item.is_with_mmr ? 'Yes' : 'No' }}<br/>
                <strong>Initial cost:</strong> {{
                  item.initial_cost ? item.initial_cost.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  }) : 'N/A'
                }}
              </div>
              <div class="col-12 col-sm-6 col-md-4">
                <q-badge :color="item.result === 'failed' ? 'red' : 'green'">
                  {{ item.result.toUpperCase() }}
                </q-badge>
                {{ item.message }}
              </div>
            </div>
          </q-card>
        </div>
        <div class="loading-infinite" v-if="isLoading">
          <div>
            <q-spinner-facebook color="primary" size="40px"/>
            <div class="text-grey-7">Loading</div>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <vehicle-sell-dialog></vehicle-sell-dialog>
  </q-dialog>
</template>

<script>
import axios from "@/axios";
import VehicleSellDialog from "@/components/VehicleSellDialog.vue";

export default {
  name: "VehicleSellHistoryDialog",
  components: {VehicleSellDialog},
  data() {
    return {
      companies: [],
      results: [
        {
          label: 'Success',
          value: 'success'
        },
        {
          label: 'Failed',
          value: 'failed'
        }
      ],
      filter: {
        company: null,
        result: null,
        keyword: '',
      },
      per: 10,
      page: 1,
      lastPage: 1,
      items: [],
      selectedItems: [],
      isLoading: false,
    }
  },
  computed: {
    setSellHistoryDialog: {
      get() {
        return this.$store.state.vehicle.setSellHistoryDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_SELL_HISTORY_DIALOG', val)
      }
    },
    setSellDialog: {
      get() {
        return this.$store.state.vehicle.setSellDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_SELL_DIALOG', val)
      }
    },
  },
  methods: {
    async getCompanies() {
      this.isLoading = true
      const {data} = await axios.get('/companies')
      this.companies = data.data.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
      this.isLoading = false
    },
    async getItems() {
      const params = {
        per: this.per,
        page: this.page,
      }
      if (this.filter.company !== null) {
        params.company_id = this.filter.company
      }
      if (this.filter.result !== null) {
        params.result = this.filter.result
      }
      if (this.filter.keyword !== '') {
        params.q = this.filter.keyword
      }

      this.isLoading = true
      const {data} = await axios.get('/sell/history', {params})
      this.lastPage = data.data.pagination.last

      let deep = () => {
        if (this.page === 1) {
          return data.data.items.map(item => item)
        } else {
          let carbon = [...this.items]
          let nextPage = data.data.items.map(item => item)
          return carbon.concat(nextPage)
        }
      }
      this.items = deep()
      this.isLoading = false
    },
    toggleSelectedItem(item) {
      const formattedItem = {
        id: item.vehicle.id,
        vin: item.vehicle.vin,
        company: item.vehicle.company,
        location: item.vehicle.location,
        brand: item.vehicle.brand,
        model: item.vehicle.model,
        model_detail: item.vehicle.model_detail,
        model_year: item.vehicle.model_year,
        condition: item.vehicle.condition,
        last_mileage_record: item.vehicle.last_mileage_record,
        is_with_mmr: item.is_with_mmr,
        retail: item.retail,
        wholesale: item.wholesale,
        initial_cost_selection: item.initial_cost !== null,
        initial_cost: item.initial_cost,
      }
      formattedItem.location.due_location_name = item.due_location_name
      formattedItem.location.pickup_location_number = item.pickup_location_number
      const index = this.selectedItems.findIndex(i => i.id === formattedItem.id)
      if (index === -1) {
        this.selectedItems.push(formattedItem)
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    clearSelectedItems() {
      this.selectedItems = []
    },
    getSelectedItemClass(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.vehicle.id)
      if (index !== -1) {
        return ' selected'
      }
      return ''
    },
    sellVehicles() {
      this.setSellDialog = {
        show: true,
        items: this.selectedItems,
        nested: true,
        completed: false,
      }
    },
    reset() {
      this.page = 1
      this.lastPage = 1
      this.items = []
      this.selectedItems = []
    },
    onScroll(e) {
      const obj = e.target
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight && this.items.length !== 0 &&
        !this.loading && this.page < this.lastPage) {
        this.page++
        this.getItems()
      }
    },
    close() {
      this.loading = false
      this.results = []
      this.$store.commit('vehicle/SET_SELL_HISTORY_DIALOG', {
        show: false
      })
    }
  },
  watch: {
    setSellHistoryDialog: {
      deep: true,
      async handler(val) {
        const el = document.querySelector('.scroll-content')
        if (val.show) {
          this.reset()
          await this.getCompanies()
          await this.getItems()
          setTimeout(() => {
            el.addEventListener('scroll', this.onScroll)
          }, 1000)
        } else {
          el.removeEventListener('scroll', this.onScroll)
        }
      }
    },
    setSellDialog: {
      deep: true,
      async handler(val) {
        if (val.completed) {
          this.page = 1
          this.selectedItems = []
          await this.getItems()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.odd {
  background-color: #f5f5f5;
}

.selected {
  background-color: #dadada;
  border-color: #7e7e7e;
}
</style>
